import { Label } from "components/atoms";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import {
  PiCheckCircle,
  PiClock,
  PiHourglassMedium,
  PiSealQuestion,
  PiWarningCircle,
  PiXCircle,
} from "react-icons/pi";
import { STATEMENT_STATUS } from "services/statements/types";
import { IColorProp } from "types/components/components.interface";

export interface ILabeledStatementStatusProps {
  status: STATEMENT_STATUS;
}

interface ILabeledStatementStatusParams extends IColorProp {
  status: STATEMENT_STATUS;
  icon: ReactNode;
}

const labeledStatusParams: ILabeledStatementStatusParams[] = [
  {
    status: STATEMENT_STATUS.unknown,
    color: "gray",
    icon: <PiSealQuestion />,
  },
  {
    status: STATEMENT_STATUS.waiting,
    color: "orange",
    icon: <PiClock />,
  },
  {
    status: STATEMENT_STATUS.accepted,
    color: "blue",
    icon: <PiCheckCircle />,
  },
  {
    status: STATEMENT_STATUS.error,
    color: "red",
    icon: <PiWarningCircle />,
  },
  {
    status: STATEMENT_STATUS.done,
    color: "green",
    icon: <PiCheckCircle />,
  },
  {
    status: STATEMENT_STATUS.inProgress,
    color: "gray",
    icon: <PiHourglassMedium />,
  },
  {
    status: STATEMENT_STATUS.canceled,
    color: "black",
    icon: <PiXCircle />,
  },
];

const LabeledStatementStatus = ({ status }: ILabeledStatementStatusProps) => {
  const { t } = useTranslation();
  const labeledParams =
    labeledStatusParams.find((params) => params.status === status) ??
    labeledStatusParams[0];
  return (
    <Label
      size="compact"
      color={labeledParams.color}
      title={t(
        `enum.STATEMENT_STATUS.${STATEMENT_STATUS[labeledParams.status]}`
      )}
    >
      {labeledParams.icon}{" "}
      {t(`enum.STATEMENT_STATUS.${STATEMENT_STATUS[labeledParams.status]}`)}
    </Label>
  );
};

export default LabeledStatementStatus;
